<template>
  <v-container fluid>
    <BaseTableWithPermissionCheck
      :items="items_filterd"
      :headers="setNGWheaders"
      title="Festlegung: NGW"
      componentName="InvoiceSetNGW"
      :editMutation="'updateSetNGW'"
      :deleteMutation="'updateSetNGW'"
      @refresh="updateList"
      @itemDeleted="onItemDeleted"
      :loading="loading"
      isApprovedButton
      :userName="data.usr"
    />
  </v-container>
</template>

<script>
import { API } from 'aws-amplify';
import { listSetNGWS, listOverwriteNGWS } from '@/graphql/queries';
import BaseTableWithPermissionCheck from '@/components/BaseTableWithPermissionCheck.vue';
import { mapGetters } from 'vuex';

export default {
  name: 'set_NGW',
  components: {
    BaseTableWithPermissionCheck,
  },
  async created() {
    this.updateList();
    this.data.usr = this.kurzel;
    this.getCacheOverwriteNGWs();
    this.getCacheOverwriteNGWApprovalLut();
    this.getMarketingMailLUT();
  },
  watch: {
    '$route.query.id'() {
      if (this.$route.query.id) {
        this.items_filterd = this.items.filter((i) => i.timestamp === Number(this.$route.query.id));
        console.log(JSON.stringify(this.$route.query.id));
      } else {
        this.items_filterd = this.items;
      }
    },
  },
  methods: {
    updateList() {
      this.getList();
      this.getOverwriteNGWList();
    },
    onItemDeleted(deletedItem) {
      // console.log('DEBUG: onItemDeleted called with:', deletedItem);
      if (!deletedItem) {
        console.log('DEBUG: No deleted item provided');
        return;
      }
      this.sendDeletionEmail(deletedItem);
    },
    sendDeletionEmail(item) {
      // console.log('DEBUG: sendDeletionEmail called with item:', item);
      
      const approver = this.getMarketingMailApprover(item.subpublisher_displayname);
      console.log('DEBUG: Marketing mail approver:', approver);
      
      const emailFragment = this.getEmailFragment(item);
      // console.log('DEBUG: Email fragment:', emailFragment);
      
      const input = {
        body: {
          marketingMailApprover: approver,
          controllerEmail: this.getControllerEmail(item.subpublisher_displayname),
          managerEmail: this.getManagerEmail(item.subpublisher_displayname),
          deleteMailSubject: `INFO: Löschung der NGW-Festlegung für ${item.article_displayname}/${item.marketing_sub_type_cd}/${item.condition_group}/${item.valid_until}`,
          deleteMailContent: `Hallo,\n\n${this.data.usr} hat folgende NGW-Festlegung gelöscht:\n\nArtikel: ${item.article_displayname}\nWerbeweg: ${item.marketing_type_cd}\nUnterwerbeweg: ${item.marketing_sub_type_cd}\nKondition: ${item.condition_group}\nGültig von: ${item.valid_from}\nGültig bis: ${item.valid_until}\nVeränderung des NGWs von ${item.ngwValue ? item.ngwValue.split(',')[5] : 'N/A'}€ auf ${item.ngw36_ov}€, voraussichtliche Gesamtveränderung 0 € bei Anfomenge 0\n${emailFragment}\nGrund: ${item.reason}\n\nGrund für die Löschung: ${item.deleteReason || 'Nicht angegeben'} \n\n`,
          mailFoot: `\n\nViele Grüße,\n${this.data.usr}`,
          delete_email: true
        }
      };
      
      // console.log('DEBUG: Email input prepared:', JSON.stringify(input, null, 2));
      // console.log('DEBUG: About to call API.post...');
      
      API.post('datauiRestAPI', '/sendApprovalEmail', input)
        .then((result) => {
          console.log('DEBUG: API call successful! Result:', JSON.stringify(result));
        })
        .catch((err) => {
          console.log('DEBUG: API call failed! Error:', err);
          console.log('DEBUG: Error details:', JSON.stringify(err, null, 2));
        });
    },
    getEmailFragment(item) {
      return `Festgeschrieben wurde der NGW auf ${item.ngw36_ov}€\n`;
    },
    getMarketingMailApprover(subpublisher_displayname) {
      if (!subpublisher_displayname || !this.marketingMailLut) {
        return [];
      }
      let approver = [];
      this.marketingMailLut.forEach((i) => {
        if (i.subpublisher_displayname === subpublisher_displayname) {
          approver = i.controller;
        }
      });
      return approver;
    },
    getControllerEmail(subpublisher_displayname) {
      if (!subpublisher_displayname || !this.approvalList) {
        return '';
      }
      return this.approvalList[subpublisher_displayname]?.Controller || '';
    },
    getManagerEmail(subpublisher_displayname) {
      if (!subpublisher_displayname || !this.approvalList) {
        return '';
      }
      return this.approvalList[subpublisher_displayname]?.Manager || '';
    },
    async getList() {
      this.loading = true;
      const response = await API.graphql({
        query: listSetNGWS,
        variables: {
          limit: 1000
        }
      });
      this.items = response.data.listSetNGWS.items.filter((i) => i.delete_marked === false);
      this.items.map((i) =>
        i.controller_confirmed
          ? (i.controller_confirmed_toshow = i.controller)
          : (i.controller_confirmed_toshow = '')
      );
      this.items.map((i) =>
        i.manager_confirmed
          ? (i.manager_confirmed_toshow = i.manager)
          : (i.manager_confirmed_toshow = '')
      );
      this.items.map((i) => {
        i.ngwIST = i.ngwValue.split(',')[5];
        i.ngwSOLL = i.newNGW.split(',')[5];
      });
      this.$store.commit('setSetNGW_items', this.items);
      this.$store.commit('setSetNGW_headers', this.setNGWheaders);
      // console.log(this.items);
      
      if (this.$route.query.id) {
        this.items_filterd = this.items.filter((i) => i.timestamp === Number(this.$route.query.id));
        console.log(JSON.stringify(this.$route.query.id));
      } else {
        this.items_filterd = this.items;
      }
      this.loading = false;
    },
    async getOverwriteNGWList() {
      this.loading = true;
      const response = await API.graphql({
        query: listOverwriteNGWS,
        variables: {
          limit: 1000
        }
      });
      this.ngw_items = response.data.listOverwriteNGWS.items.filter((i) => i.delete_marked === false);
      this.ngw_items.map((i) =>
        i.controller_confirmed
          ? (i.controller_confirmed_toshow = i.controller)
          : (i.controller_confirmed_toshow = '')
      );
      this.ngw_items.map((i) =>
        i.manager_confirmed
          ? (i.manager_confirmed_toshow = i.manager)
          : (i.manager_confirmed_toshow = '')
      );
      this.ngw_items.map((i) => {
        i.ngwIST = i.ngwValue.split(',')[5];
        i.ngwSOLL = i.newNGW.split(',')[5];
      });
      this.$store.commit('setOverWriteNGW_items', this.ngw_items);
      this.$store.commit('setOverWriteNGW_headers', this.OverwriteNGWheaders);
      

      this.loading = false;
    },
    getCacheOverwriteNGWs: function () {
      this.loading = true;
      API.get('datauiRestAPI', `/overwriteNGWCache?fachverlagArticleLut=${true}`, {})
        .then((result) => {
          let temp = JSON.parse(result);
          this.dropDownValues = temp;
          this.$store.commit('setOverWriteNGW_dropDownValues', this.dropDownValues);
        })
        .catch((err) => {
          console.log(err);
        });
      this.loading = false;
    },
    getCacheOverwriteNGWApprovalLut: function () {
      this.loading = true;
      API.get('datauiRestAPI', '/ngwApprovalLut', {})
        .then((result) => {
          result = JSON.parse(JSON.stringify(result));
          let uniqueSubpublisher = [...new Set(result.map((i) => i.subpublisher_displayname))];
          let list_m = {};
          uniqueSubpublisher.forEach((j) => {
            result.forEach((a) => {
              if (a.subpublisher_displayname === j) {
                let list = {
                  Controller: a.controller,
                  Manager: a.manager,
                };
                list_m[j] = list;
              }
            });
          });
          // console.log(list_m);
          this.approvalList = list_m;
          this.$store.commit('setOverWriteNGW_approvalList', this.approvalList);
        })
        .catch((err) => {
          console.log(err);
        });
      this.loading = false;
    },
    getMarketingMailLUT: function () {
      this.loading = true;
      API.get('datauiRestAPI', '/overwriteNGWControllerMailLut', {})
        .then((result) => {
          this.marketingMailLut = result;
          // this.marketingMailLut.forEach(i => console.log(i.subpublisher_displayname));
          this.$store.commit('setOverWriteNGW_controllerMailLut', this.marketingMailLut );
        })
        .catch((err) => {
          console.log(err);
        });
      this.loading = false;
    },
  },
  data() {
    return {
      setNGWheaders: [
        // { text: 'Fachverlag', value: 'subpublisher_displayname' },
        { text: 'Artikel', value: 'article_displayname' },
        { text: 'Werbeweg ', value: 'marketing_type_cd', thStyle: { width: "3%" } },
        { text: 'Unter-werbeweg ', value: 'marketing_sub_type_cd', thStyle: { width: "3%" } },
        { text: 'Kondition', value: 'condition_group' },
        { text: 'NGW IST', value: 'ngwIST' },
        { text: 'NGW SOLL', value: 'ngw36_ov' },
        { text: 'Grund', value: 'reason' },
        { text: 'Gültig von', value: 'valid_from' },
        { text: 'Gültig bis', value: 'valid_until' },
        { text: 'Controller Approved', value: 'controller_confirmed_toshow' },
        { text: 'Manager Approved', value: 'manager_confirmed_toshow' },
        { text: 'Über-schreibung Aktiv', value: 'active' },
      ],
      OverwriteNGWheaders: [
        // { text: 'Fachverlag', value: 'subpublisher_displayname' },
        { text: 'Artikel', value: 'article_displayname' },
        { text: 'Werbeweg ', value: 'marketing_type_cd', thStyle: { width: "3%" } },
        { text: 'Unter-werbeweg ', value: 'marketing_sub_type_cd', thStyle: { width: "3%" } },
        { text: 'Kondition', value: 'condition_group' },
        // { text: 'Betrachtungsmonat', value: 'anfo_month' },
        { text: 'Grenz-Typ Wandlung', value: 'ov_cp_minMax' },
        { text: 'Wandlung in Vert. bez.', value: 'cas_00_r03' },
        { text: 'Wandlung Überschreibung ', value: 'ov_cp_contractPayedRatioThreshold' },
        { text: 'Grenz-Typ Haltbarkeit', value: 'ov_m_minMax' },
        { text: 'Monate in Abo', value: 'cas_36_r03' },
        { text: 'Monate Überschreibung', value: 'ov_m_monthThreshold' },
        { text: 'NGW IST', value: 'ngwIST' },
        { text: 'NGW SOLL', value: 'ngwSOLL' },
        { text: 'Grund', value: 'reason' },
        { text: 'Gültig von', value: 'valid_from' },
        { text: 'Gültig bis', value: 'valid_until' },
        { text: 'Controller Approved', value: 'controller_confirmed_toshow' },
        { text: 'Manager Approved', value: 'manager_confirmed_toshow' },
        { text: 'Über-schreibung Aktiv', value: 'active' },
      ],
      items: [],
      items_filterd: [],
      loading: true,
      data: { usr: '' },
      dropDownValues: [],
      marketingMailLut: [],
      approvalList: [],
    };
  },
  computed: {
    ...mapGetters(['user', 'kurzel']),
  },
};
</script>
